import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, first } from 'rxjs/operators';
import { AppConfigService } from 'src/environments/app-config.service';
import { HandleErrorService } from 'src/app/services/handle-error/handle-error.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectBaselineActivityService {
  private environment: any;
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient,
    private appConfig: AppConfigService,
    private handleErrorService: HandleErrorService
  ) {
    this.environment = this.appConfig.config;
    this.apiUrl = `${this.environment.apiIssuer}/baselines-activity`;
  }

  public getBaselinesActivity(): Observable<any> {
    return this.httpClient.get<any>(`${this.apiUrl}?activeIndicator=true`).pipe(
      first(),
      catchError(err => this.handleErrorService.handleErrorWithoutRedirectToPing(err))
    );
  }
}
